const __vite_glob_0_4 = "/* document layout */\n.light-mode .t-doc .layout-content,\n.dark-mode .t-doc .layout-content {\n  background: transparent;\n}\n";
export {
  __vite_glob_0_4 as default
};
//# sourceMappingURL=kepler.css.js.map
